// 第三方协同开票 票易通
import api from '@/api'

const state = {

}

const mutations = {

}

const actions = {
  getAssignUrl ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.getAssignUrl(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/posc/getAssignUrl', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/posc/getAssignUrl', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/piaoYiTong.js